<!-- Toolbar -->
<div class="toolbar" role="banner">
  <img class="logo" src="/assets/img/verisk_tm_h_full-color_rgb.png" alt="Verisk logo">
  <span>Status Page</span>
    <div class="spacer"></div>
</div>

<div class="content" role="main">
  <router-outlet></router-outlet>
</div>
